import React from 'react'
import { useSelector } from 'react-redux'
import { selectShouldDisplayMapLayersButton } from '../../../store/map/map.selectors'
import LayersButtons from '../common/LayersButtons'
import useMapMoveHandler from '../useMapMoveHandler'
import useMapPaddingHandler from '../useMapPaddingHandler'
import useMapPerfMetrics from '../useMapPerfMetrics'
import useMapPointerHandler from '../useMapPointerHandler'
import useMapZoomHandler from '../useMapZoomHandler'
import MapTooSlowTooltip from './MapTooSlowTooltip'
import useClickMapEventsHandler from './useClickMapEventsHandler'
import useClickMyMapLayers from './useClickMyMapLayers'

const VectorMap = () => {
  useClickMyMapLayers()
  useMapPointerHandler()
  useClickMapEventsHandler()
  useMapMoveHandler()
  useMapZoomHandler()
  useMapPaddingHandler()
  useMapPerfMetrics()

  const shouldDisplayMapLayersButton = useSelector(selectShouldDisplayMapLayersButton)

  return shouldDisplayMapLayersButton ? null : (
    <>
      <MapTooSlowTooltip />
      <LayersButtons />
    </>
  )
}

export default VectorMap
